module.exports = __webpack_public_path__ + "img/volleyball-dark.66e13ac3.svg";